import { useCallback } from "react";
import { Button } from "../../../../externalComponents/tailwind/button";
import { Dialog, DialogActions, DialogBody, DialogTitle } from "../../../../externalComponents/tailwind/dialog";
import { Text } from "../../../../externalComponents/tailwind/text";

const AlertDialog = ({ modalRef, setModalRef, data, headerType, navigate }) => {

  const handleClose = useCallback(() => {
    setModalRef(_modalRef => ({
      ..._modalRef,
      alert: false,
    }));
  }, [modalRef.alert]);

  return <Dialog open={modalRef.alert} onClose={handleClose}  >
    <DialogTitle>
      Missing {headerType === "image" ? "image" : "video"}
    </DialogTitle>
    <DialogBody>
      <Text className="text-md">
        {`The ${headerType} is missing. Please add it to the template before sending the campaign.`}
      </Text>
    </DialogBody>
    <DialogActions>
      <Button color="secondaryButton" onClick={handleClose}      >
        OK
      </Button>
      <Button color="primaryButton" onClick={() => navigate(`/campaigns/edit/${data.id}`)}      >
        Edit campaign
      </Button>
    </DialogActions>
  </Dialog>;

}

export default AlertDialog;
